import { Box, BoxProps, Container, ContainerProps, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface AppPageProps extends BoxProps {
  children: ReactNode;
  containerProps?: ContainerProps;
  maxW?: ContainerProps['maxW'];
  gap?: BoxProps['gap'];
}

export function AppPage({
  children,
  containerProps,
  maxW = '1440px',
  gap = { base: '5', md: '6' },
  py = { base: '4', md: '6' },
  px = { base: '3', sm: '4', md: '6', xl: '8' },
  ...props
}: AppPageProps) {
  return (
    <Box w="full" minW={0} py={py} px={px} {...props}>
      <Container maxW={maxW} w="full" px="0" {...containerProps}>
        <VStack align="stretch" gap={gap} minW={0}>
          {children}
        </VStack>
      </Container>
    </Box>
  );
}
